<template>
  <div class="overlay" v-if="active">
    <div class="modal">
      <div class="layout">
        <div class="item">
          <a
            href="#"
            class="btn navigation-icon close"
            v-on:click.prevent="active = false"
          ></a>

          <div class="wrapper">
            <div class="content embed-responsive embed-responsive-16by9">
              <!-- <iframe class="embed-responsive-item" v-bind:src='`//players.brightcove.net/2750693505001/9KXeGhtDV4_default/index.html?videoId=6018245426001`'allowfullscreen webkitallowfullscreen mozallowfullscreen allow="encrypted-media" style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 100%;"></iframe> -->
              <iframe
                class="embed-responsive-item"
                v-bind:src="`//players.brightcove.net/2750693505001/${player}_default/index.html?videoId=${id}`"
                frameborder="0"
                allowfullscreen
                webkitallowfullscreen
                mozallowfullscreen
                allow="encrypted-media"
                style="
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  bottom: 0px;
                  left: 0px;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="backdrop"><!-- backdrop --></div>
  </div>
</template>

<script>
import { scroll } from "../../mixins/index";

export default {
  name: "modal-video",
  props: {
    item: {
      type: Object,
    },
  },
  mixins: [scroll],
  data() {
    return {
      active: false,
      player: "",
      id: "",

      escapeListener: null,
    };
  },
  watch: {
    active(val) {
      bus.$emit("overlay:active:boolean", val, this.player, this.id);
      document.body.style["overflow"] = val ? "hidden" : "visible";
    },
  },
  beforeDestroy() {
    window.removeEventListener(this.escapeListener);
  },
  mounted() {
    // modal-video
    let hash = window.location.hash.substring(1);
    if (/^modal-video/.test(hash)) {
      // pattern
      // modal-video=true&video=abc&player=xyz;

      // example on:
      // en-us/sleep-apnea/snoring-sleep-apnea-diagnosis/what-causes-snoring/
      // modal-video=true&video=6093844709001&player=zzaavGefz

      let arr = hash.split("&"),
        id = arr[1].replace("video=", ""),
        player = arr[2].replace("player=", "");

      let component = $(`[modal-video-id="${id}"]`).closest(
        "[resmed-component-name]"
      )[0];

      if (component) {
        this.scroll({
          to: component,
          duration: 1200,
          callback: () => {
            this.active = true;
            this.player = player;
            this.id = id;
          },
        });
      } else {
        this.active = true;
        this.player = player;
        this.id = id;
      }
    }
  },
  created() {
    bus.$on("overlay:active", (arg) => {
      this.active = arg.active;
      this.player = arg.player;
      this.id = arg.id;
    });

    this.escapeListener = window.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        this.active = false;
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/components/modal";

.overlay {
  .layout {
    position: relative;
    margin: 6rem auto 0 auto;
    width: 960px;
    max-width: 90vw;
    box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.75);

    @media (min-height: 800px) {
      margin: 12rem auto 0 auto;
    }
  }
}
</style>